<template>
  <div
    class="flex flex-col"
    :class="[
      $style.confirmationContainer,
      { 'items-center': question.isSmileyImage },
    ]"
  >
    <div
      v-if="question.image"
      class="flex justify-center items-end overflow-hidden"
      :class="{
        'rounded-lg mb-[-8px] bg-static-info-low': !question.isSmileyImage,
      }"
    >
      <RevIllustration
        alt=""
        class="object-contain"
        :class="{
          'h-[150px] w-[150px]': question.isSmileyImage,
          [$style.image]: !question.isSmileyImage,
          'object-cover': question.key === 'functional_information',
        }"
        :height="480"
        loading="eager"
        :src="question.image"
        :width="480"
      />
    </div>
    <div class="flex flex-col relative w-full">
      <h3
        v-if="question.title"
        :class="{
          'text-center heading-2 mb-6 py-24': question.image,
          'heading-3 mb-16': !question.image,
        }"
      >
        {{ question.title }}
      </h3>
      <QuestionsFormItemText
        v-if="question.showInfo"
        :centered="!!question.image"
        :class="{
          'mb-20 self-center': question.image,
          ' mb-16': !question.image,
        }"
        :info="question.info"
      />
      <div class="flex flex-col w-full gap-8">
        <RevButton
          v-if="question.options[0]"
          :data-qa="question.key"
          fullWidth="always"
          variant="primary"
          @click="
            emit('answer', question.key, question.options[0].value as string)
          "
        >
          {{ question.options[0].label }}
        </RevButton>
        <button
          v-if="question.options[1]"
          class="body-1-bold mt-8 w-full cursor-pointer underline"
          type="button"
          @click="
            emit('answer', question.key, question.options[1].value as string)
          "
        >
          {{ question.options[1].label }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import type { RenderQuestion } from '~/scopes/buyback/composables/useFunnelQuestions'

import QuestionsFormItemText from './QuestionsFormItemText.vue'

defineProps<{
  question: RenderQuestion
}>()

const emit = defineEmits<{
  (event: 'answer', key: string, value: string): void
}>()
</script>

<style module>
.confirmationContainer {
  container-type: inline-size;
  container-name: confirmation-container;
}
.image {
  width: 100%;
}
@container confirmation-container (width > 468px) {
  .image {
    height: 372px;
    width: 480px;
  }
}
</style>
